import { render, staticRenderFns } from "./ShiftCustomFact.vue?vue&type=template&id=3ada6cac&"
import script from "./ShiftCustomFact.vue?vue&type=script&lang=ts&"
export * from "./ShiftCustomFact.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftCustomFact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports